import fileDownload from 'js-file-download'

const escapeHtml = (value: string) =>
  value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

const toCellText = (value: unknown) =>
  value === undefined || value === null ? '' : escapeHtml(String(value))

// Excel umi otevrit HTML tabulku ulozenou pod priponou .xls, bez nutnosti xlsx knihovny.
export const exportToXls = (filename: string, headers: string[], rows: unknown[][]) => {
  const headerRow = headers.map(header => `<th>${escapeHtml(header)}</th>`).join('')
  const bodyRows = rows
    .map(row => `<tr>${row.map(cell => `<td>${toCellText(cell)}</td>`).join('')}</tr>`)
    .join('')

  const html = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
<head><meta charset="utf-8" /></head>
<body><table border="1"><thead><tr>${headerRow}</tr></thead><tbody>${bodyRows}</tbody></table></body>
</html>`

  fileDownload(html, filename, 'application/vnd.ms-excel;charset=utf-8')
}
